import {
    CUSTOMER_YEAR_FILTER,
    CUSTOMER_QTR_FILTER,
    CUSTOMER_MONTH_FILTER,
    CUSTOMER_GROUP_SELECT,
    CUSTOMER_PROVINCE_SELECT,
    CUSTOMER_MARKETPLACE_SELECT,
    CUSTOMER_GROUPTABLE_SELECT,
    CUSTOMER_SALE_PROD_CARD,
    CUSTOMER_SALE_PROD,
    CUSTOMER_SALE_PROD_MONTH,
    CUSTOMER_NEWCUS_CARD,
    CUSTOMER_NEWCUS_CHART,
    CUSTOMER_ACTIVE_CARD,
    CUSTOMER_ACTIVE_CHART,
    CUSTOMER_AGING_CARD,
    CUSTOMER_AGING_CHART,
    CUSTOMER_GROUP_FILTER,
    CUSTOMER_CODE_FILTER,
    NEW_CUSTOMER_FILTER,
    CUSTOMER_PROVINCE_FILTER,
    CUSTOMER_MARKETPLACE_FILTER,
    CUSTOMER_TYPE_FILTER,
    CUSTOMER_FORMATDISPLAY_FILTER,
    CUSTOMER_LIST_KEYWORD_FILTER,
    SalesFocus_Invoice_CHART,
    CUSTOMER_SEARCH_TRIGGER
} from '../constants/ActionTypes';

export const customerSelectYear = payload => {
    return {
        type: CUSTOMER_YEAR_FILTER,
        payload
    }
}

export const customerSelectQtr = payload => {
    return {
        type: CUSTOMER_QTR_FILTER,
        payload
    }
}

export const customerSelectMonth = payload => {
    return {
        type: CUSTOMER_MONTH_FILTER,
        payload
    }
}

export const customerSelectGroup = payload => {
    return {
        type: CUSTOMER_GROUP_SELECT,
        payload
    }
}

export const customerSelectProvince = payload => {
    return {
        type: CUSTOMER_PROVINCE_SELECT,
        payload
    }
}

export const customerSelectMarketPlace = payload => {
    return {
        type: CUSTOMER_MARKETPLACE_SELECT,
        payload
    }
}

export const customerSelectGroupTable = payload => {
    return {
        type: CUSTOMER_GROUPTABLE_SELECT,
        payload
    }
}

export const customerSaleProductCard = payload => {
    return {
        type: CUSTOMER_SALE_PROD_CARD,
        payload
    }
}

export const customerSaleProduct = payload => {
    return {
        type: CUSTOMER_SALE_PROD,
        payload
    }
}

export const customerSaleProductMonth = payload => {
    return {
        type: CUSTOMER_SALE_PROD_MONTH,
        payload
    }
}

export const customerNewCusCard = payload => {
    return {
        type: CUSTOMER_NEWCUS_CARD,
        payload
    }
}

export const customerNewCusChart = payload => {
    return {
        type: CUSTOMER_NEWCUS_CHART,
        payload
    }
}

export const customerActiveCard = payload => {
    return {
        type: CUSTOMER_ACTIVE_CARD,
        payload
    }
}

export const customerActiveChart = payload => {
    return {
        type: CUSTOMER_ACTIVE_CHART,
        payload
    }
}

export const customerAgingCard = payload => {
    return {
        type: CUSTOMER_AGING_CARD,
        payload
    }
}

export const customerAgingChart = payload => {
    return {
        type: CUSTOMER_AGING_CHART,
        payload
    }
}

export const customerGroupFilter = payload => {
    return {
        type: CUSTOMER_GROUP_FILTER,
        payload
    }
}

export const customerCodeFilter = payload => {
    return {
        type: CUSTOMER_CODE_FILTER,
        payload
    }
}

export const newCustomerFilter = payload => {
    return {
        type: NEW_CUSTOMER_FILTER,
        payload
    }
}

export const customerProvinceFilter = payload => {
    return {
        type: CUSTOMER_PROVINCE_FILTER,
        payload
    }
}

export const customerMarketPlaceFilter = payload => {
    return {
        type: CUSTOMER_MARKETPLACE_FILTER,
        payload
    }
}

export const customerTypeFilter = payload => {
    return {
        type: CUSTOMER_TYPE_FILTER,
        payload
    }
}

export const customerDisplayFilter = payload => {
    return {
        type: CUSTOMER_FORMATDISPLAY_FILTER,
        payload
    }
}

export const customerListKeywordFilter = payload => {
    return {
        type: CUSTOMER_LIST_KEYWORD_FILTER,
        payload
    }
}

export const SalesFocusInvoiceChart = payload => {
    return {
        type: SalesFocus_Invoice_CHART,
        payload
    }
}

export const customerSetSearchTrigger = trigger => {
    return {
        type: CUSTOMER_SEARCH_TRIGGER,
        payload: trigger
    }
}